<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <card
            class="strpied-tabled-with-hover"
            body-classes="table-full-width table-responsive"
          >
            <template slot="header">
              <div class="d-flex justify-content-between">
                <div class="align-self-center">
                  <button
                    class="btn btn-light d-flex align-items-center text-dark p-1 border-0"
                    @click="$router.go(-1)"
                  >
                    <i class="nc-icon nc-stre-left font-weight-bold"></i>
                    <p class="m-0 ml-1">Voltar a lista</p>
                  </button>
                  <div class="row">
                    <div class="col-12">
                      <proposta-form :proposta="proposta"></proposta-form>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import LTable from 'src/components/Table.vue';
import PropostaForm from './Forms/PropostaForm.vue';
import PropostaService from 'src/services/proposta';
import vPagination from 'vue-plain-pagination';
import VTooltip from 'v-tooltip';
import { MENSAGEM_ERRO_DEFAULT } from 'src/utils/constants';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

const tableColumns = ['', ''];
export default {
  components: {
    LTable,
    vPagination,
    VTooltip,
    PropostaForm
  },
  data() {
    return {
      tabelaLinhaDoTempo: {
        columns: [...tableColumns],
        data: []
      },
      proposta: {},
      codigo: '',
      isVisibleModalNovaMensagem: false,
      novaMensagem: '',
      isVisibleModalConverter: false
    };
  },
  created() {
    this.codigo = this.$router.history.current.params.codigo;
    this.getProposta();
  },
  methods: {
    getProposta() {
      const loader = this.createLoading();
      PropostaService.getByCodigo(this.codigo)
        .then(response => {
          var proposta;
          proposta = _.get(response, 'data');
          this.proposta = { ...proposta };
          loader.hide();
        })
        .catch(error => {
          loader.hide();
          const message = _.has(error, 'response.data.message')
            ? _.get(error, 'response.data.message')
            : MENSAGEM_ERRO_DEFAULT;
          this.notify({
            message,
            type: 'danger'
          });
          this.$router.replace('');
        });
    },
    createLoading() {
      return this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });
    },
    notify({ type, message }) {
      let icon = '';
      switch (type) {
        case 'info':
          icon = 'fa fa-info';
          break;
        case 'success':
          icon = 'fa fa-check';
          break;
        case 'danger':
          icon = 'fa fa-exclamation-triangle';
      }
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: 'center',
        verticalAlign: 'top',
        type: type
      });
    },
    parseDate(date) {
      const year = date.slice(0, 4);
      const month = date.slice(5, 7);
      const day = date.slice(8, 10);
      return `${day}/${month}/${year}`;
    }
  }
};
</script>
<style scoped>
.height-fit-content {
  height: fit-content;
}
</style>
